import { Button, IconButton, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useFieldArray } from 'react-hook-form';

type Props = {
    control: any;
    name: string;
    defaultObject: any;
    render: (props: { index: number; deleteButton: any }) => React.ReactNode;
    addMoreText: string;
};

const AddMore = (props: Props) => {
    const [init, setInit] = useState(false);
    const { fields, append, remove } = useFieldArray({
        control: props.control, // control props comes from useForm (optional: if you are using FormContext)
        name: props.name, // unique name for your Field Array
    });

    const deleteButton = index => {
        return (
            <IconButton
                size="small"
                color="error"
                onClick={e => {
                    e.stopPropagation();
                    remove(index);
                }}>
                    <i className="fi fi-br-trash" style={{ fontSize: 16 }} />
            </IconButton>
        );
    };

    useEffect(() => {
        if (fields.length === 0 && !init) {
            append(props.defaultObject, { shouldFocus: false });
            setInit(true);
        }
    }, [append, fields, init, props.defaultObject]);

    return (
        <Stack spacing={2}>
            {fields.map((field, index) => {
                return (
                    <React.Fragment key={field.id}>
                        {props.render({
                            index,
                            deleteButton: deleteButton(index),
                        })}
                    </React.Fragment>
                );
            })}
            <Button
                variant="outlined"
                color="secondary"
                size="small"
                fullWidth
                onClick={() => append(props.defaultObject)}
                startIcon={<i className="fi fi-br-plus" style={{ fontSize: 14 }} />}>
                {props.addMoreText}
            </Button>
        </Stack>
    );
};

export default AddMore;
